module.exports = __webpack_public_path__ + "img/DE01009.f21ccf9e.png";